import React from "react";
import AttentionPane from "./AttentionPane/AttentionPane";
import ConversationPane from "./ConversationPane/ConversationPane";
import CostPane from "./CostPane/CostPane";
import DocumentPane from "./DocumentPane/DocumentPane";
import LocationPane from "./LocationPane/LocationPane";
import "./ShipmentDetailsPane.scss";
import UpdatePane from "./UpdatePane/UpdatePane";
import ContainerPane from "./ContainerPane/ContainerPane";
import WatcherPane from "./WatcherPane/WatcherPane";
import { Result } from "antd";

const ShipmentDetailsPane = ({ pane, shipment }) => {
  return (
    <div className="ShipmentDetailsPane">
      {
        pane === "attentions" ? <AttentionPane shipment={shipment} />
          : pane === "updates" ? <UpdatePane shipment={shipment} />
            : pane === "location" ? <LocationPane shipment={shipment} />
              : pane === "documents" ? <DocumentPane shipment={shipment} />
                : pane === "cost" ? <CostPane shipment={shipment} />
                  : pane === "containers" ? <ContainerPane shipment={shipment} />
                    : pane === "conversations" ? <ConversationPane shipment={shipment} />
                      : pane === "watchers" ? <WatcherPane shipment={shipment} />
                        : <Result
                          status="404"
                          title="404"
                          subTitle="Sorry, the page you visited does not exist."
                        />
      }
    </div>
  )
}

export default ShipmentDetailsPane;
